import { createContext, useContext } from 'react';
import { DefaultStorage } from '../../storage';

export const AdminTokenStorageContext = createContext<DefaultStorage>(undefined!);

export function useAdminTokenStorage() {
  return useContext(AdminTokenStorageContext);
}
